"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Newsletter = void 0;
var _react = _interopRequireDefault(require("react"));
var _PrimaryLayout = require("b2b-components/theme/components/PrimaryLayout");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Newsletter.scss");
const Newsletter = _ref => {
  let {
    className,
    hasNewsletterDisplayed,
    renderNewsletterForm,
    text
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-FooterNewsletter', className);
  if (!hasNewsletterDisplayed) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement(_PrimaryLayout.PrimaryLayout, {
    className: "cds-FooterNewsletter-Content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-FooterNewsletter-Info"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-FooterNewsletter-Title"
  }, text.newsletterTitle), /*#__PURE__*/_react.default.createElement("p", {
    className: "cds-FooterNewsletter-Text"
  }, text.newsletterText)), renderNewsletterForm()));
};
exports.Newsletter = Newsletter;
//# sourceMappingURL=Newsletter.js.map